import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/followers/importer/followersImporterActions'

export default importerReducers(actions)
